export default __webpack_public_path__ + "static/media/smartplan_navicon.77a2dade.svg";